import { WidgetsHelper } from '../tools/WidgetsHelper'
import deleteEmmitsByWidgetType from '../variables/deleteEmmitsByWidgetType'

export default {
  inject: {
    stateName: { default: '' },
    getDataContract: { default: () => () => { return {  contractName: '' } } } // по умолчанию возвращаем функцию, которая возвращает объект
  },
  props: ['model', 'dataSource', 'parentDataWidget', 'readonly', 'parentsWidgets'],
  computed: {
    widgetsHelper() {
      return new WidgetsHelper(this.stateName, this.$store)
    },
    currentListOfParentsWidgets() {
      return !this.parentsWidgets ? [this.model] : [...this.parentsWidgets, this.model]
    },
    isInEditorMode() {
      return this.$store.state[this.stateName].isEditorMode
    },
    isInSnippetEditor() {
      return this.$store.state[this.stateName].isSnippetEditor
    },
    currentUIKit() {
      if (!this.isInEditorMode) {
        return this.$store.state.appRunner?.model?.Settings?.UIKit || ''
      }
      return this.$store.getters.currentUIKit
    },
    moduleName() {
      return this.$store.state.global.currentModuleRouteParam
    },
    isSelected() {
      return this.$store.state[this.stateName].selectedWidget == this.model && this.model !== undefined
    },
    wrapOn() {
      return {
        deleteComponent: this.onDeleteComponent,
        replaceComponent: this.onReplaceComponent
      }
    },
    classes() {
      if (!this.model) {
        return {}
      }

      return { classes: this.model.Class || '', hideOnMobile: this.model.HideOnMobile, hideOnTablet: this.model.HideOnTablet, hideOnPC: this.model.HideOnPC }
    }
  },

  methods: {
    onWidgetDraggableAdd(event) {
      const widget = event.item._underlying_vm_
      const onSetSelectedWidgetFromBreadCrumb = new CustomEvent('onSetSelectedWidget', {
        bubbles: true,
        cancelable: true,
        detail: { widgetId: widget.$ID }
      })

      document.body.dispatchEvent(onSetSelectedWidgetFromBreadCrumb)
      this.onModelChanged()
    },
    onDeleteComponent() {
      if (!this.isInEditorMode || this.readonly) {
        return
      }

      // Создания патча в случае если rts mode включён
      const isRtsModeActive = this.$store.state.featureFlags.rtsMode

      if (isRtsModeActive) {
        this.$store.dispatch('jsonPatches/createRemovePatch', {
          selectedWidget: this.model,
          pathToTarget: `Modules.${this.moduleName}`,
          publish: true
        })
      }

      // Полная очистка breadcrumns
      this.widgetsHelper.resetBreadcrumbs()

      // Emmit для некоторых виджетов будет отличатся, поэтому нужно по типу виджета вызывать определённые $emmit
      const deleteEventName = deleteEmmitsByWidgetType[this.model.$Type] || 'deleteComponent'
      this.$emit(deleteEventName, this.model)
    },
    async selectComponent(value) {
      if (!this.isInEditorMode) {
        return
      }
      let contract = null
      if (this.getDataContract) {
        contract = await this.getDataContract()
      }

      this.addParentsSelectedWidget(value)
      this.widgetsHelper.setSelectedWidget(value, contract)
    },
    addParentsSelectedWidget(value) {
      //Текущая страница
      const currentPage = this.$store.getters[`${this.stateName}/pageModel`]
      //Если выбраный виджет - страница, добавить её и не делать ничего лишнего
      if (value.$Type === 'dr-page') {
        this.widgetsHelper.setupBreadcrumbs([currentPage])
        return
      }
      //Изначальный список родительских виджетов
      let listOfParentsWidget = this.currentListOfParentsWidgets
      
      //Если начальный виджет - страница
      if (currentPage !== undefined && listOfParentsWidget[0].$Type !== 'dr-page') {
        listOfParentsWidget.splice(0, 0, currentPage)
      }
      this.widgetsHelper.setupBreadcrumbs(listOfParentsWidget)
    },
    onReplaceComponent(payload) {
      if (!this.isInEditorMode || this.readonly) {
        return
      }
      this.$emit('replaceComponent', payload)
    },
    deleteKeyupEventHandler() {
      if (this.isSelected) {
        this.onDeleteComponent()
      }
    },
    setSelectedWidgetEvent(event) {
      if (this.model?.$ID && this.model.$ID === event?.detail?.widgetId) {
        this.selectComponent(this.model, event.detail.parentsWidget)
      }
    }
  },
  beforeMount() {
    if (this.isInEditorMode) {
      window.document.body.addEventListener('onKeyUpDeleteWidgetEvent', this.deleteKeyupEventHandler)
      window.document.body.addEventListener('onSetSelectedWidget', this.setSelectedWidgetEvent)
    }
  },
  beforeDestroy() {
    window.document.body.removeEventListener('onKeyUpDeleteWidgetEvent', this.deleteKeyupEventHandler)
    window.document.body.removeEventListener('onSetSelectedWidget', this.setSelectedWidgetEvent)
  }
}